<div class="menu-icon__lines" [title]="'app-menu' | translate">
  <span></span>
  <span></span>
  <span></span>
</div>
